// extracted by css-extract-rspack-plugin
export default {"select":"UqW5ukoLXGMdxspR__select___"};